export default "\n<span class=\"small pr-2\">{{version}} / {{feature}}</span>\n\n"